/* eslint-disable vue/no-reserved-component-names */
/* eslint-disable vue/multi-word-component-names */
import { createApp } from 'vue'
import { createPinia } from 'pinia';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import piniaPluginPersistedState from 'pinia-plugin-persistedstate';
import VueTheMask from 'vue-the-mask';
import 'nemesiselements/style.css'

import App from '@/App.vue';
import router from '@/router';
import axios from '@/plugins/axios';
import { setupLenis } from '@/plugins/lenis';
import { setupSentry } from '@/plugins/sentry';
import { setupPrimeVue } from '@/plugins/primevue';
import { setupGlobalComponents } from '@/plugins/globalComponents';
import { setupNemesisChart } from '@/plugins/nemesischart';
import { setupNemesisElements } from '@/plugins/nemesiselements';
import { apenasNumeros, apenasAlfanumerico } from '@/directives/filtrosEntrada';

import { useRuntimeConfig } from "@/composables/useRuntimeConfig";
import { locale_pt_br } from './commons/utils';

const { apiBaseUrl, appEnv } = useRuntimeConfig();
const isProd = appEnv.value !== 'local';
const app = createApp(App);

setupSentry(app, router);

const pinia = createPinia();
pinia.use(piniaPluginPersistedState);

setupNemesisChart(app);
setupNemesisElements(app);
setupPrimeVue(app, locale_pt_br);
setupGlobalComponents(app);

const { recaptchaSiteKey } = useRuntimeConfig();
app.use(VueReCaptcha, {
  siteKey: recaptchaSiteKey.value,
  loaderOptions: {
    autoHideBadge: true,
  },
});

app.use(pinia);
app.use(router);
app.use(axios, {
  baseURL: apiBaseUrl.value,
  token: null,
});
app.use(VueTheMask);

app.directive('apenas-numeros', apenasNumeros);
app.directive('apenas-alfanumerico', apenasAlfanumerico);

gsap.registerPlugin(ScrollTrigger);
setupLenis(app);
app.config.globalProperties.$gsap = gsap;
app.provide('gsap', gsap);

if (isProd) {
  console.log(
    '%c🚨🚫 Pare! Este é um recurso para desenvolvedores.',
    'color: #ff4757; font-size: 35px; font-weight: bold; text-shadow: 2px 2px 0px rgba(0,0,0,0.3);'
  );
  console.log(
    '%cSe alguém disse para você copiar e colar algo aqui para ativar um recurso ou "hackear" a conta de alguém, isso é uma farsa e dará a eles acesso à sua conta do Arlo.',
    'color: #dedadbff; font-size: 16px; font-weight: bold;'
  );
}

app.mount('#app');
